import React, { ChangeEvent, Dispatch, useEffect, useRef, useState } from 'react'
import { AdministrativeLevel, AdministrativeLevels, FlatAdmin } from '../createWarningComp/CreateWarningTypes';
import { AdminData } from '../createWarningComp/MapSelectorPopup';
import { maldivesAdministrativeLevel, sriLankaAdministrationLevel } from '../createWarningComp/FixedDataSet';
import { dividerClasses } from '@mui/material';
import { flatMap, paginationList } from '../createWarningComp/CommonMethods';
import { DownIcon, UpIcon } from '../iconSet/IconSet';

export type AdminDataType = {
    isSelected: true;
    name: string;
    code: string;
    adminName: string;
    adminLevel: string;
}

export type NewUserAreaTablePropsType = {
    selectedRows: string[]
    setSelectedRows: Dispatch<React.SetStateAction<string[]>>
}

export const NewUserAreaTable = (props: NewUserAreaTablePropsType) => {
    // Selected country
    const country = process.env.REACT_APP_COUNTRY

    const [hiddenIslandCodes, setHiddenIslandCodes] = useState<string[]>([])
    
    // Number of rows in table
    const [numberOfRows, setNumberOfRows] = useState<number>(10)
    const numberOfRowsRef = useRef<HTMLInputElement | null>(null)

    const [filterTableData, setFilterTableData] = useState<FlatAdmin[]>([])
    const [tableData, setTableData] = useState<FlatAdmin[]>([])
    const [pagination, setPagination] = useState<FlatAdmin[][]>([])
    const [selectedPagination, setSelectedPagination] = useState<number>(0)

    const [HRWTableData, setHRWTableData] = useState<AdminDataType[]>([])
    const HRWTableDataRef = useRef<AdminData[]>([])

    // true = A -> Z
    // false = Z -> A
    const [adminNameSort, setAdminNameSort] = useState<Boolean>(true)
    const adminNameSortHandle = () => {
        setAdminNameSort(prevState => !prevState)
    }
    useEffect(() => {
        setFilterTableData(prevState => {
            return [...prevState].sort((a, b) => {
                const adminNameComparison = adminNameSort ? a.name.localeCompare(b.name) : b.name.localeCompare(a.name)
                return adminNameComparison
            })
        })
    }, [adminNameSort])

    const [adminSort, setAdminSort] = useState<Boolean>(true)
    const adminSortHandle = () => {
        setAdminSort(prevState => !prevState)
    }
    useEffect(() => {
        setFilterTableData(prevState => {
            return [...prevState].sort((a, b) => {
                const adminComparison = adminSort ? a.adminLevel.localeCompare(b.adminLevel) : b.adminLevel.localeCompare(a.adminLevel)
                return adminComparison
            })
        })
    }, [adminSort])

    // Handle Row number change
    const handleRowNumberChanged = (event: ChangeEvent<HTMLInputElement>) => {
        setNumberOfRows(event.target.valueAsNumber)
    }

    // Handle table search
    const handleSearchChange = (event: ChangeEvent<HTMLInputElement>) => {
        if (event.target.value === "") {
            setFilterTableData(tableData)
        } else {
            setFilterTableData(prevState => prevState.filter(item => item.name.toLowerCase().includes(event.target.value.toLowerCase()) || item.adminLevel.toLowerCase().includes(event.target.value.toLowerCase())))
        }
    }

    const [selectedArea, setSelectedArea] = useState<string[]>(props.selectedRows)
    const handleCheckBox = (event: React.ChangeEvent<HTMLInputElement>) => {

        if (event.target.checked) {
            setSelectedArea(prevState => [...prevState, event.target.name])
        } else {
            setSelectedArea(prevState => prevState.filter(item => item !== event.target.name))
        }
    }

    useEffect(() => {
        props.setSelectedRows(selectedArea)
    }, [selectedArea])

    // Handle check box click
    const handleCheckBoxClick = (event: ChangeEvent<HTMLInputElement>) => {
        handleCheckBox(event);

        const code = event.target.name;
        const isChecked = event.target.checked;

        /* setRowStates(prev => {
            const newState = { ...prev };
            if (isChecked && !newState[code]) {
            newState[code] = {
                isSelected: true,
                previousAlert: "",
                newAlertLevel: "",
                rainfall: 0, // Initialize to 0
                lightingRiskLevel: "",
                startDate: startDate || "",
                endDate: endDate || ""
            };
            } else if (!isChecked) {
                delete newState[code];
            }
            return newState;
        }); */

        // Determine which admin structure to use
        const adminSource = country === 'SRI_LANKA' ? sriLankaAdministrationLevel : maldivesAdministrativeLevel;

        // Find the clicked admin level (atoll or island)
        const clickedAdminLevel = findAdminByCode(adminSource, code);
        console.log("clickedAdminLevel ->", clickedAdminLevel)
        
        // If it's an atoll, toggle island visibility
        if (clickedAdminLevel && clickedAdminLevel.adminLevel === 'atoll') {
            const childIslandCodes = getAllChildIslandCodes(clickedAdminLevel);
            setHiddenIslandCodes(prev =>
              isChecked ? [...prev, ...childIslandCodes] : prev.filter(code => !childIslandCodes.includes(code))
            );
          }

        if (event.target.checked) {
            const alreadyExists = HRWTableData.some(item => item.code === event.target.name)
            
            if (!alreadyExists) 
            {
                const data = tableData.find(obj => obj.code === event.target.name);
                if (data) {

                    setHRWTableData(prevState => {
                        return [...prevState, {
                            isSelected: true,
                            name: data.name,
                            code: data.code,
                            adminName: data.adminLevel,
                            adminLevel: data.adminLevel,
                        }]
                    })
                }
            }
        } else {
            // Remove item by filtering based on nested data.code
            setHRWTableData(prevState => prevState.filter(item => !(item.code === event.target.name)))
        }
    }

    const getAllChildIslandCodes = (level: AdministrativeLevel): string[] => {
        if (!level.children) return [];

        const codes: string[] = [];
        Object.entries(level.children).forEach(([code, child]) => {
            if (child.adminLevel === 'island') {
                codes.push(code);
            }

            // Recurse deeper
            codes.push(...getAllChildIslandCodes(child));
        });

        return codes;
    }

    const findAdminByCode = (levels: AdministrativeLevels, code: string): AdministrativeLevel | null => {
        for (const [key, level] of Object.entries(levels)) {
            if (key === code) return level;
            if (level.children) {
            const result = findAdminByCode(level.children, code);
            if (result) return result;
            }
        }
        return null;
    }

    // Pagination next prev navigation
    const paginationNavigation = (side: "next" | "prev") => {
        if (side === "next") {
            if (pagination.length > selectedPagination + 1) {
                setSelectedPagination(prevState => prevState + 1)
                console.log(">>>> good next")
            }

        } else if (side === "prev") {
            if (0 <= selectedPagination - 1) {
                setSelectedPagination(prevState => prevState - 1)
            }
        }
    }

    useEffect(() => {
        if (country === "SRI_LANKA") {
            const flat = flatMap(sriLankaAdministrationLevel, selectedArea)
            setTableData(flat)
            setFilterTableData(flat)
        } else if (country === "MALDIVES") {
            const flat = flatMap(maldivesAdministrativeLevel, selectedArea)
            setTableData(flat)
            setFilterTableData(flat)
        }
    }, [])

    useEffect(() => {
        setPagination(paginationList(filterTableData, numberOfRows))
    }, [tableData, filterTableData, numberOfRows])

    useEffect(() => {
        //console.log("IS CLICKED ADMIN LEVEL 1: ", hiddenIslandCodes)
        const visibleData = filterTableData.filter(item => !hiddenIslandCodes.includes(item.code));
        //console.log("IS CLICKED ADMIN LEVEL 2: ", visibleData)
        const paginated = paginationList(visibleData, numberOfRows);
        setPagination(paginated);

        // Reset to first page if current page is out of bounds after filtering
        if (selectedPagination >= paginated.length) {
            setSelectedPagination(0);
        }
    }, [filterTableData, numberOfRows, hiddenIslandCodes])

    useEffect(() => {
        if (props.selectedRows.length > 0 && tableData.length > 0) {
            const initialSelectedData = tableData
                .filter(item => props.selectedRows.includes(item.code))
                .map(item => ({
                    isSelected: true as true,
                    name: item.name,
                    code: item.code,
                    adminName: item.adminLevel,
                    adminLevel: item.adminLevel,
                }));
            
            setHRWTableData(initialSelectedData);
        }
    }, [props.selectedRows, tableData]);

    // useEffect(() => {
    //     const adminSource = country === 'SRI_LANKA' ? sriLankaAdministrationLevel : maldivesAdministrativeLevel;
    
    //     const hiddenChildren: string[] = [];
    
    //     props.selectedRows.forEach(code => {
    //         //const admin = findAdminByCode(adminSource, code);
    //         const clickedAdminLevel = findAdminByCode(adminSource, code);
    //         // If it's an atoll, toggle island visibility
    //         if (clickedAdminLevel && clickedAdminLevel.adminLevel === 'atoll') {
    //             const childIslandCodes = getAllChildIslandCodes(clickedAdminLevel);
                
    //             setHiddenIslandCodes(prev => [...prev, ...childIslandCodes]);
    //         }

    //         const alreadyExists = HRWTableData.some(item => item.code === code)
            
    //         if (!alreadyExists) 
    //         {
    //             const data = tableData.find(obj => obj.code === code);
    //             if (data) {

    //                 setHRWTableData(prevState => {
    //                     return [...prevState, {
    //                         isSelected: true,
    //                         name: data.name,
    //                         code: data.code,
    //                         adminName: data.adminLevel,
    //                         adminLevel: data.adminLevel,
    //                     }]
    //                 })
    //             }
    //         }
    //     });
        
    // }, [props.selectedRows]);

    const handleSelectAllCheckbox = (event: ChangeEvent<HTMLInputElement>) => {
        const isChecked = event.target.checked

        // Get all currently visible rows (after filtering and hiding children)
        const visibleRows = filterTableData.filter(item => !hiddenIslandCodes.includes(item.code));
        const visibleCodes = visibleRows.map(item => item.code);

        if (isChecked) {
            // Add all visible codes to selectedArea, avoiding duplicates
            setSelectedArea(prev => Array.from(new Set([...prev, ...visibleCodes])));

            // Add visible rows to HRWTableData if not already there
            setHRWTableData(prev => {
                const newRows = visibleRows.filter(vr => !prev.some(hrw => hrw.code === vr.code))
                    .map(vr => ({
                        isSelected: true as true,
                        name: vr.name,
                        code: vr.code,
                        adminName: vr.adminLevel,
                        adminLevel: vr.adminLevel,
                    }));
                return [...prev, ...newRows];
            });

        } else {
            // Remove all visible codes from selectedArea
            setSelectedArea(prev => prev.filter(code => !visibleCodes.includes(code)));

            // Remove from HRWTableData
            setHRWTableData(prev => prev.filter(item => !visibleCodes.includes(item.code)));
        }
    }

    return (
        <div className='user-area-select-table-wraaper'>
            <div className='details-selector-wrapper-table-container'>
                <div className='area-table-wrapper'>
                    <span className='title'>User Specific areas</span>
                    <div className='field-wrapper'>
                        <div className='left'>
                            <span>show <input type="number" ref={numberOfRowsRef} defaultValue={10} min={10} onChange={(e) => handleRowNumberChanged(e)}/> entries</span>
                        </div>
                        <div className='right'>
                            <span> search <input type="text" onChange={(e) => handleSearchChange(e)} placeholder='Search location'/></span>
                        </div>
                    </div>
                    {/* <div className='field-container'>
                        <div className='input-group' style={{ width: '20rem' }}>
                            <label htmlFor="">Show</label>
                            <input ref={numberOfRowsRef} defaultValue={10} min={10} max={30} type="number" onChange={(e) => handleRowNumberChanged(e)} />
                        </div>
                        <div className='input-group'>
                            <i><SearchIcon width="1rem" color="var(--color-main-white)" /></i>
                            <input type="text" name="" id="" placeholder='Search location' onChange={handleSearchChange} />
                        </div>
                    </div> */}
                    <div className='table-wrapper'>
                        <div className='row header'>
                            <div className='cell' style={{ flex: 0.2, minWidth: '3rem', maxWidth: '3rem' }}>
                                <span>
                                    <input type="checkbox" className='select-all-checkbox' onChange={(e) => handleSelectAllCheckbox(e)}/>
                                </span>
                            </div>
                            <div className='cell' style={{ minWidth: '8.3rem' }} onClick={(e) => adminNameSortHandle()}>
                                <span style={{ gap: '0.5rem' }}>
                                    Administration Name
                                    <div>
                                        {adminNameSort ? (
                                            <UpIcon width="1rem" color="var(--color-main-white)" />
                                        ) : (
                                            <DownIcon width="1rem" color="var(--color-main-white)" />
                                        )}
                                        
                                    </div>
                                </span>
                            </div>
                            <div className='cell' style={{ minWidth: '8.3rem' }} onClick={(e) => adminSortHandle()}>
                                <span style={{ gap: '0.5rem' }}>
                                    Administration Level
                                    <div>
                                        {adminSort ? (
                                            <UpIcon width="1rem" color="var(--color-main-white)" />
                                        ) : (
                                            <DownIcon width="1rem" color="var(--color-main-white)" />
                                        )}
                                        
                                    </div>
                                </span>
                            </div>
                        </div>

                        {pagination[selectedPagination]?.map((item, index) => {
                            const currentRowState = HRWTableData.find((row) => row.code === item.code) ?? {
                                isSelected: false,
                                code: item.code,
                                name: item.name,
                                adminName: item.name,
                                adminLevel: item.adminLevel,
                            };

                        return (
                            <div key={index} className='row'>
                                <div className='cell' style={{flex: 0.2, minWidth: '3rem'}}>
                                    <input type="checkbox" name={item.code} checked={currentRowState.isSelected} onChange={(e) => handleCheckBoxClick(e)} />
                                </div>
                                <div className='cell' style={{minWidth: '8rem'}}>
                                    <span>{item.name}</span>
                                </div>
                                <div className='cell' style={{minWidth: '8rem'}}>
                                    <span>{item.adminLevel}</span>
                                </div>
                            </div>
                        );
                    })}

                    </div>
                </div>
                <div className='pagination-wrapper'>
                    <div className='icon-page-box' style={{ marginBottom: "0.7rem" }} onClick={(e) => paginationNavigation("prev")}>&lt;</div>
                    <div className='page-wrapper'>
                        {pagination.map((page, index) => (
                            <div key={index} className={selectedPagination === index ? 'icon-page-box selected' : 'icon-page-box'} onClick={(e) => setSelectedPagination(index)}>{index + 1}</div>
                        ))}
                    </div>
                    <div className='icon-page-box' style={{ marginBottom: "0.7rem" }} onClick={(e) => paginationNavigation("next")}>&gt;</div>
                </div>
            </div>
        </div>
        
    )
}
